import styled from 'styled-components';
import vars from './vars';

/**
 * Disclosure accordion built on native `<details>` / `<summary>`. Same border,
 * radius, primaryColorLight highlight on open, and +/– toggle indicator used
 * across the apps.
 *
 * Composition:
 *
 *   <Collapse>
 *       <CollapseSummary>Heading</CollapseSummary>
 *       <CollapseBody>...</CollapseBody>
 *   </Collapse>
 *
 * Site-specific tweaks (font-weight, gap, media queries, body padding) should
 * extend via `styled(Collapse)` / `styled(CollapseSummary)` / `styled(CollapseBody)`
 * rather than redefining the base.
 */
export const Collapse = styled.details`
    border: 1px solid ${vars.dividerColor};
    border-radius: 6px;
    background-color: ${vars.backgroundColor};
    overflow: hidden;
    user-select: none;
    -webkit-user-select: none;

    &[open] > summary {
        background-color: ${vars.primaryColorLight};
        border-bottom: 1px solid ${vars.dividerColor};
    }

    &[open] > summary::after {
        content: '–';
    }
`;

export const CollapseSummary = styled.summary`
    list-style: none;
    cursor: pointer;
    padding: 12px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    &::-webkit-details-marker {
        display: none;
    }

    &::after {
        content: '+';
        font-weight: 700;
        margin-left: 8px;
    }

    &:focus-visible {
        outline: 2px solid ${vars.foregroundColor};
        outline-offset: 2px;
    }
`;

export const CollapseBody = styled.div`
    padding: 16px;
`;
